import { Box, Text } from '@betty/moonlight';
import ShopMisteryBoxInfoItemList from '../ShopMisteryBoxInfoItemList/ShopMisteryBoxInfoItemList';
import { MysteryBoxItemDropType } from '../../state/items/items.types';
import { memo } from 'react';

function ShopMysteryBoxInfoTopPrizes({
  items,
}: {
  items: MysteryBoxItemDropType[];
}) {
  if (!items.length) return null;

  return (
    <Box
      variant="gradient"
      gradient="accentBackground"
      borderRadius="radius-400"
      position="relative"
      paddingHorizontal="space-200"
      paddingVertical="space-400"
      marginBottom="space-300"
      marginTop="space-400"
    >
      <Box
        position="absolute"
        backgroundColor="screenBackground"
        top="space-050"
        bottom="space-050"
        right="space-050"
        left="space-050"
        borderRadius="radius-400"
      />
      <Box
        position="absolute"
        variant="gradient"
        gradient="accentBackground"
        padding="space-200"
        borderRadius="radius-200"
        left="space-200"
        top="-space-400"
      >
        <Text
          locNS="shop"
          locKey="shopMisteryBoxTopPrizesLabel"
          variant="badge"
          color="accentSurfacePrimary"
        />
      </Box>
      <ShopMisteryBoxInfoItemList items={items} />
    </Box>
  );
}

export default memo(ShopMysteryBoxInfoTopPrizes);
